import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtTextFieldPWD from "../Components/CustomTool/CtTxtPWD";
import CtCmb from "../Components/CustomTool/CtCmb";
import CtTxtNum from "../Components/CustomTool/CtTxtNum";
import MaterialTable from "../Components/CustomTool/MaterialTable";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
// import DepartmentMaster from "./DepartmentMaster";
import { Stack } from "@mui/material";
// import PlantMaster from "./PlantMaster";
// import { fetchUser } from "../Components/API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import { fetchLopPrice } from "./API";
import MobileTable from "./CustomTool/MobileTable";
import CtART from "./CustomTool/ResponsiveTable";
import axios from "axios";
import CtTxtAmt from "../Components/CustomTool/CtTxtAmt";
import CtCmbEditable from "./CustomTool/CtCmbEditable";

class LopPriceMaster extends Component {
  state = {
    Unit: [{ vac_type: "Type" }],
    DisplayType: [],
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
      },
      {
        accessorKey: "vac_button_type",
        header: "Button Type",
      },
      {
        accessorKey: "vac_display_type",
        header: "Display Type",
      },
      {
        accessorKey: "dec_per_button_price",
        header: "Per Button Price",
      },
      {
        accessorKey: "dec_single_button_lop_price",
        header: "Price Of Single Button LOP",
      },
    ],

    rows: [],
    formData: {
      bint_srno: 0,
      cmbButtonType: "",
      cmbDisplayType: "",
      txtPerButtonPrice: "",
      txtPriceOfSingleLop: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "LOP Price Master");
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      this.props.modules.lopprice
    );
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveLopPrice,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.cmbButtonType
        );
      }
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_button_type",
      "vac_display_type",
      "dec_per_button_price",
      "dec_single_button_lop_price",
    ]);
    const bint_srno = row.bint_srno,
      cmbButtonType = row.vac_button_type,
      cmbDisplayType = row.vac_display_type,
      txtPerButtonPrice = row.dec_per_button_price,
      txtPriceOfSingleLop = row.dec_single_button_lop_price;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        cmbButtonType,
        cmbDisplayType,
        txtPerButtonPrice,
        txtPriceOfSingleLop,
      },
    });
    document.getElementById("cmbButtonType").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_button_type"]);
    this.DeleteData(row.bint_srno, row.vac_button_type);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListLopPrice",
    };
    fetchLopPrice(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.ListLopPrice,
          rowsCount = rows.length,
          DisplayType =
            res.data.DisplayType.length > 0 ? res.data.DisplayType : [];
        this.setState({
          rowsCount,
          rows,
          DisplayType,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("cmbButtonType").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          cmbButtonType: "",
          cmbDisplayType: "",
          txtPerButtonPrice: "",
          txtPriceOfSingleLop: "",
        },
      },
      () => {
        document.getElementById("cmbButtonType").focus();
      }
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationLopPrice = () => {
    let result = false;
    if (this.state.formData.cmbButtonType.length <= 0) {
      this.props.toastErrorMsg("Select Button Type", "cmbButtonType");
    } else if (this.state.formData.cmbDisplayType.length <= 0) {
      this.props.toastErrorMsg("Enter Display Type", "cmbDisplayType");
    } else if (this.state.formData.txtPerButtonPrice.length <= 0) {
      this.props.toastErrorMsg("Enter Per Button Price", "txtPerButtonPrice");
    } else if (this.state.formData.txtPriceOfSingleLop.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Price Of Single Button LOP",
        "txtPriceOfSingleLop"
      );
    } else {
      result = true;
    }
    return result;
  };

  saveLopPrice = () => {
    this.trimFormData(() => {
      if (this.validationLopPrice()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveLopPrice",
          bint_srno: this.state.formData.bint_srno,
          vac_button_type: this.state.formData.cmbButtonType,
          vac_display_type: this.state.formData.cmbDisplayType,
          dec_per_button_price: this.state.formData.txtPerButtonPrice,
          dec_single_button_lop_price: this.state.formData.txtPriceOfSingleLop,
        };
        fetchLopPrice(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (res.data.ListLopPrice && res.data.ListLopPrice.length > 0) {
                rows = res.data.ListLopPrice;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Lop Price .", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_button_type) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete Button type : ${vac_button_type} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLopPrice(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteLopPrice = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteLopPrice",
      bint_srno: bint_srno,
    };
    fetchLopPrice(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.ListLopPrice && res.data.ListLopPrice.length > 0) {
            rows = res.data.ListLopPrice;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            }
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Lop Price. " + error
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveLopPrice}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.cmbButtonType
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          {/* <Grid item>
            <CtTxt
              id="cmbButtonType"
              label="Button Type*"
              maxLength={100}
              width="220"
              value={this.state.formData.cmbButtonType}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid> */}

          <Grid item>
            <CtCmb
              id="cmbButtonType"
              label="Button Type*"
              items={this.props.ButtonType}
              value={this.state.formData.cmbButtonType}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              colID="vac_button_type"
            />
          </Grid>
          {/* <Grid item>
            <CtTxt
              id="cmbDisplayType"
              label="Display Type*"
              maxLength={100}
              width="220"
              value={this.state.formData.cmbDisplayType}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid> */}
          <Grid item>
            <CtCmb
              id="cmbDisplayType"
              label="Display Type*"
              items={this.state.DisplayType}
              value={this.state.formData.cmbDisplayType}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              colID="vac_displaytype"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtPerButtonPrice"
              label="Per Button Price*"
              maxLength={100}
              width="220"
              value={this.state.formData.txtPerButtonPrice}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
              RupeeSymbol={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtPriceOfSingleLop"
              label="Price Of Single Button LOP*"
              maxLength={100}
              width="220"
              value={this.state.formData.txtPriceOfSingleLop}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
              defaultAction={this.saveLopPrice}
              RupeeSymbol={true}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          {/* responsive table */}
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Lop Price")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={80}
              density={"compact"}
              hideColIdList={["bint_srno"]}
            />
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <LopPriceMaster {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
